import { GridRowParams } from '@mui/x-data-grid';
import { GridApiCommunity } from '@mui/x-data-grid/internals';
import React from 'react';

import { doesUpdatingRowHaveRequiredFields, isUpdatingRowUnique } from 'components/atoms/EditableDataGrid/helpers';
import { ModelType } from 'interfaces/modelType';
import { idField } from 'interfaces/modelType/modelTypeFields';
import { uuidv4 } from 'utils/helpers';
import { ModelTypeDraft } from './types';

export const generateDraftId = () => `draft-${uuidv4()}`;
export const getModelTypeId = (row: ModelType | ModelTypeDraft) =>
  (row as ModelTypeDraft).draftId ?? row.id ?? generateDraftId();

export const getModelTypeError = ({
  id,
  apiRef,
}: GridRowParams<ModelType> & {
  apiRef: React.MutableRefObject<GridApiCommunity>;
}) => {
  const hasDuplicateId = !isUpdatingRowUnique({
    apiRef,
    rowId: id,
    uniqueFields: ['id'],
    getId: getModelTypeId,
  });
  const idError = idField.getError?.({ value: apiRef?.current?.getRowWithUpdatedValues?.(id, 'id').id });

  const hasDuplicateDisplayName = !isUpdatingRowUnique({
    apiRef,
    rowId: id,
    uniqueFields: ['displayName'],
    getId: getModelTypeId,
  });

  const missingId = !doesUpdatingRowHaveRequiredFields({
    apiRef,
    rowId: id,
    requiredFields: ['id'],
  });

  const missingDisplayName = !doesUpdatingRowHaveRequiredFields({
    apiRef,
    rowId: id,
    requiredFields: ['displayName'],
  });

  const missingType = !doesUpdatingRowHaveRequiredFields({
    apiRef,
    rowId: id,
    requiredFields: ['type'],
  });

  return hasDuplicateId
    ? 'Duplicate ID'
    : missingId
    ? 'Missing ID'
    : idError
    ? idError
    : hasDuplicateDisplayName
    ? 'Duplicate display Name'
    : missingDisplayName
    ? 'Missing display Name'
    : missingType
    ? 'Missing Type'
    : '';
};
